import { axiosCustomerV3 } from 'modules/axios'
import { CONFIG } from './environment'

export function findAllSubscriptions(accountId) {
  return axiosCustomerV3({
    method: 'GET',
    url: `${CONFIG.api.customerSubscriptions}/${accountId}/subscriptions`,
  }).then(resp => resp.data)
}
